import React from 'react';
import Carousel from '../../../components/Carousel';
import ForumCard from './ForumCard';
import {useQuery} from "@tanstack/react-query";
import {
    FEATURE_TOPICS_KEY,
    fetchHomeTopics
} from "../../../../api/public-voissa/features";

const ForumHome = () =>{
    const {isSuccess : isSuccessTopics, data : dataTopics} = useQuery(
        [FEATURE_TOPICS_KEY],
        ()=> fetchHomeTopics(),
        {
            staleTime : (1000 * 60 * 5),
            placeholderData : {
                data : [],
            },
            select : (data) =>{
                return data.data || [];
            }
        }
    );

    return (
        <Carousel>
            <div className="pane">
                <div className="row">
                    {isSuccessTopics && dataTopics && dataTopics.slice(0, 4).map((article) => (
                        <ForumCard
                            key={article._id}
                            {...article}
                        />
                    ))}
                </div>
                <div className="row">
                    {isSuccessTopics && dataTopics && dataTopics.slice(4, 8).map((article) => (
                        <ForumCard
                            key={article._id}
                            {...article}
                        />
                    ))}
                </div>
            </div>
            <div className="pane">
                <div className="row">
                    {isSuccessTopics && dataTopics && dataTopics.slice(8, 12).map((article) => (
                        <ForumCard
                            key={article._id}
                            {...article}
                        />
                    ))}
                </div>
                <div className="row">
                    {isSuccessTopics && dataTopics && dataTopics.slice(12, 16).map((article) => (
                        <ForumCard
                            key={article._id}
                            {...article}
                        />
                    ))}
                </div>
            </div>
        </Carousel>
    )
};

export default ForumHome;